function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:red;}.cls-2{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "lostandfound");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "swiss-flag-graphic_Image",
  "data-name": "swiss-flag-graphic\\xA0Image"
}, React.createElement("rect", {
  className: "cls-1",
  width: 97,
  height: 95.5
}), React.createElement("path", {
  className: "cls-2",
  d: "M110.13,141.45h21.8v18.48h-21.8v25H90v-25H68.13V141.45H90v-24.3h20.14Z",
  transform: "translate(-51 -102)"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "LOST_FOUND",
  "data-name": "LOST & FOUND"
}, React.createElement("path", {
  className: "cls-2",
  d: "M171.67,136.15h17.54v7.27h-27V102.69h9.48Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M226.2,126.73a17,17,0,0,1-4.77,12.41Q216.66,144,209,144t-12.56-4.88a16.94,16.94,0,0,1-4.81-12.41V119.4a17,17,0,0,1,4.8-12.39q4.8-4.9,12.52-4.9a16.73,16.73,0,0,1,12.48,4.9,17,17,0,0,1,4.81,12.39Zm-9.43-7.39a11.78,11.78,0,0,0-2.06-7.16,7.49,7.49,0,0,0-11.67,0,11.89,11.89,0,0,0-2,7.18v7.39a11.88,11.88,0,0,0,2.06,7.22,6.87,6.87,0,0,0,5.89,2.8,6.72,6.72,0,0,0,5.76-2.8,11.94,11.94,0,0,0,2-7.22Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M253.31,132.63a4.07,4.07,0,0,0-1.43-3.33,18.22,18.22,0,0,0-5.12-2.49q-7.72-2.43-11.44-5.22a9.43,9.43,0,0,1-3.72-8,9.73,9.73,0,0,1,4.43-8.28,18.92,18.92,0,0,1,11.26-3.16,17.12,17.12,0,0,1,11.09,3.48,10.62,10.62,0,0,1,4.18,9l-.06.17h-9.18a5.14,5.14,0,0,0-1.65-4,6.47,6.47,0,0,0-4.56-1.52,7.14,7.14,0,0,0-4.48,1.26A3.8,3.8,0,0,0,241,113.6a3.29,3.29,0,0,0,1.64,2.87,32.88,32.88,0,0,0,6.14,2.7q6.94,2.07,10.45,5.09a10.38,10.38,0,0,1,3.51,8.31,9.81,9.81,0,0,1-4.18,8.41q-4.18,3-11.09,3a20.66,20.66,0,0,1-12-3.48,11.11,11.11,0,0,1-4.92-10l.06-.17h9.2q0,3.53,1.9,5t5.76,1.51a6.84,6.84,0,0,0,4.38-1.17A3.78,3.78,0,0,0,253.31,132.63Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M296.28,110H285.54v33.46h-9.48V110H265.4v-7.27h30.89Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M320,122a24.63,24.63,0,0,1-2.67-4.62,10.9,10.9,0,0,1-.88-4.25,10.55,10.55,0,0,1,3.16-7.93,11.51,11.51,0,0,1,8.37-3.06,9.64,9.64,0,0,1,10,9.79,10.52,10.52,0,0,1-1.27,5.09,11.52,11.52,0,0,1-3.46,3.92l-2.43,1.71,6.83,7.83a13.32,13.32,0,0,0,1.51-3.44,14.42,14.42,0,0,0,.53-3.94h6.66a28.19,28.19,0,0,1-.88,7.27,17,17,0,0,1-2.81,5.88l6.15,7.08-.06.14H338.45l-2.07-2.35a19.9,19.9,0,0,1-4.85,2.22,18.8,18.8,0,0,1-5.33.71q-6.1,0-9.71-3.19a10.6,10.6,0,0,1-3.61-8.34,8.91,8.91,0,0,1,1.72-5.53,26,26,0,0,1,5.33-4.94Zm6.83,14.77a11.91,11.91,0,0,0,2.42-.25,11.37,11.37,0,0,0,2.39-.78l-7.47-8.45-.25.17a6.75,6.75,0,0,0-1.22,2.11,7.25,7.25,0,0,0-.35,2.31,4.91,4.91,0,0,0,1.3,3.52A4.21,4.21,0,0,0,326.83,136.74ZM324.62,113a5.21,5.21,0,0,0,.53,2.22,12.93,12.93,0,0,0,1.59,2.48l1.68-1.06a6.16,6.16,0,0,0,2.1-2,4.22,4.22,0,0,0,.53-2.1,3.28,3.28,0,0,0-.85-2.21,2.84,2.84,0,0,0-2.25-1,3,3,0,0,0-2.46,1A3.87,3.87,0,0,0,324.62,113Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M188,181.53H171.67v16.39h-9.48V157.19h28.65v7.27H171.67v9.79H188Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M228.8,181.23A17,17,0,0,1,224,193.63q-4.77,4.88-12.46,4.88T199,193.63a16.94,16.94,0,0,1-4.81-12.41V173.9A17,17,0,0,1,199,161.5q4.8-4.9,12.52-4.9A16.73,16.73,0,0,1,224,161.5a17,17,0,0,1,4.81,12.39Zm-9.43-7.39a11.79,11.79,0,0,0-2.06-7.16,7.49,7.49,0,0,0-11.67,0,11.89,11.89,0,0,0-2,7.18v7.39a11.88,11.88,0,0,0,2.06,7.22,6.87,6.87,0,0,0,5.89,2.8,6.72,6.72,0,0,0,5.76-2.8,11.94,11.94,0,0,0,2-7.22Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M267.72,157.19v26.69q0,7-4.63,10.8T251,198.52q-7.58,0-12.23-3.83t-4.64-10.8V157.19h9.48v26.69q0,3.75,1.93,5.55a7.69,7.69,0,0,0,5.46,1.8,7.52,7.52,0,0,0,5.39-1.79q1.89-1.79,1.89-5.57V157.19Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M307.92,197.93h-9.43l-14.91-26-.17.06v25.91h-9.48V157.19h9.48l14.91,26,.17-.06V157.19h9.43Z",
  transform: "translate(-51 -102)"
}), React.createElement("path", {
  className: "cls-2",
  d: "M314.33,197.93V157.19H329a16.62,16.62,0,0,1,12,4.69,16,16,0,0,1,4.84,12v7.33a16,16,0,0,1-4.84,12,16.64,16.64,0,0,1-12,4.67Zm9.48-33.46v26.19h4.59a7.22,7.22,0,0,0,5.9-2.59,10.44,10.44,0,0,0,2.13-6.84v-7.39a10.34,10.34,0,0,0-2.13-6.8,7.24,7.24,0,0,0-5.9-2.57Z",
  transform: "translate(-51 -102)"
}));

var SvgLostandfound = function SvgLostandfound(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 297.82 96.52",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLostandfound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lostandfound.bf93da19.svg";
export { ForwardRef as ReactComponent };